import axios from "axios";

let prevCode = "";
let bDSMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

function onBarcodeReady(barcodeResult) {
    barcodeResult.map((barcode) => {
        const decodedResult = DSScanner.bin2String(barcode);

        if (decodedResult != prevCode) {
            prevCode = decodedResult;

            axios
                .get("/api/product/get/ean/" + decodedResult)
                .then((response) => {
                    if (typeof response.data.error !== "undefined") {
                        notyf.dismissAll();
                        notyf.open({
                            type: "error",
                            message: response.data.error,
                        });
                    } else {
                        window.location.href = response.data.data.url;
                    }
                });
        }
    });
}

function onError(err) {
    notyf.open({
        type: "error",
        message: err.message,
    });
    prevCode = "";
}

function getVideoDevices() {
    DSScanner.getVideoDevices((devices) => {
        let cameraSelect = document.querySelector("#camera");

        if (devices && devices.length) {
            if (localStorage.getItem('camera') === null) {
                if( bDSMobile ) {
                    var camIdx = SelectBestCamera( devices );
                    if( camIdx >= 0 ) {
                        localStorage.setItem('camera', devices[camIdx].id);
                        cameraSelect.value = devices[camIdx].id;
                    } else {
                        localStorage.setItem('camera', devices[0].id);
                        cameraSelect.value = devices[0].id;
                    }
                } else {
                    cameraSelect.value = devices[0].id;
                    localStorage.setItem('camera', devices[0].id);
                }
            } else {
                cameraSelect.value = localStorage.getItem('camera');
            }

            devices.forEach((device) => {
                let option = document.createElement("option");
                option.text = device.label;
                option.value = device.id;
                cameraSelect.add(option);
            });

            cameraSelect.value = localStorage.getItem('camera');
            cameraSelect.addEventListener("change", (event) => {
                let newCameraId = event.target.value;

                localStorage.setItem('camera', newCameraId);

                const scannerSettings = {
                    camera: {
                        id: newCameraId,
                    },
                };
                DSScanner.setScannerSettings(scannerSettings);
            });
        }
    });
}

function CreateScanner(device) {
    let key = "";

    const subdomains = location.hostname.split('.');
    if(subdomains.includes('gb')){
        key = process.env.MIX_BARCODE_GB_KEY;
    } else if(subdomains.includes('eu')) {
        key = process.env.MIX_BARCODE_EU_KEY;
    } else if(subdomains.includes('us')) {
        key = process.env.MIX_BARCODE_US_KEY;
    } else if(subdomains.includes('fr')) {
        key = process.env.MIX_BARCODE_FR_KEY;
    } else if(subdomains.includes('au')) {
        key = process.env.MIX_BARCODE_AU_KEY;
    }

    const scannerSettings = {
        scanner: {
            framerTimeout: 200,
            barcodeTimeout: 3000, // 3 seconds timeout for each scan
            key: key,
            outputDebug: false,
        },
        viewport: {
            id: "reader",
        },
        camera: {
            id: localStorage.getItem('camera') ? localStorage.getItem('camera') : device ? device.id : null,
            label: device ? device.label : null,
            resx: 640,
            resy: 480,
            facingMode: 'environment'
        },
        barcode: {
            barcodeTypes: ["EAN13"],
        },
    };

    getVideoDevices();

    DSScanner.addEventListener("onError", onError);
    DSScanner.addEventListener("onBarcode", onBarcodeReady);

    DSScanner.addEventListener("onScannerReady", function (frameSize) {
        const scannerSettings = {
            scanner: {
                scanningRect: { left: frameSize.width / 4, top: frameSize.height / 4, width: frameSize.width / 2, height: frameSize.height / 2 },
            }
        }
        DSScanner.setScannerSettings(scannerSettings);
        DSScanner.StartScanner();
    });

    DSScanner.Create(scannerSettings);
}

function SelectBestCamera(camArr)
{
    var _result = -1;
    var minCamIdx = 9999;
    for( var i=0; i < camArr.length; ++i )
    {
        //find 'back' in camera label, and select min camera idx
        var matchArr = camArr[i].label.match(/[a-z0-9]+\s+(\d)+,.*(back).*/i);
        if( matchArr && matchArr.length == 3 && parseInt(matchArr[1]) < minCamIdx )
            _result = i;
    };

    return _result;
}

document.addEventListener("DOMContentLoaded", () => {
    CreateScanner();
});
